import { createFileRoute, redirect } from "@tanstack/react-router";

/* The module's own address had no page and rendered an empty layout. It opens
   on the conversations, the one screen outside Settings; that route keeps its guard. */
export const Route = createFileRoute("/_authenticated/_shelby/shelby/")({
  beforeLoad: () => {
    throw redirect({ to: "/shelby/conversations", replace: true });
  },
});
